import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useDistributor = (id) => useQuery({ queryKey: [`distributor`, id], queryFn: async () => {
    const callback = await API.get(`/distributors/${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 60, gcTime: 1000 * 60 * 60 * 24 })

export default useDistributor